import React from 'react';
import {BaseProps} from "../../infrastructure/models/props/base-props";
import {EntityViewModel} from "../../infrastructure/models/entity/entity.view-model";
import {DeviceViewModel} from "../models/device.view-model";
import {WithDevice} from "./composers/with-device";
import {Ellipsis} from "./misc/ellipsis/ellipsis";

export class EntityDisplayNameProps extends BaseProps {
  entity: EntityViewModel;
  device: DeviceViewModel;
  className: String;
  numOfMaxLines: Number;
}

export const EntityDisplayName = WithDevice((props: EntityDisplayNameProps) => {
  const name: String = props.device.isSmallView && props.entity.shortName ? props.entity.shortName : props.entity.name;

  return (
    <Ellipsis text={name} className={props.className} numOfMaxLines={props.numOfMaxLines}/>
  )
});
